// 08/2018 Kyle Reworked to make applicable to multiple pages (Videos, Printables, etc.)
(function(){
    SUGApp.controller('categoryController', ['$scope', function (s) {
        s.section = 'all';
        s.showcategory = function ( category ) {
        s.section = category;
        };
    }]);
})();

// Landing Pages Controller
(function(){
    SUGApp.controller('subgroupController', ['$scope','$location', function ($scope,$location) {
        // Extract the path value from the url
        var urlTab = $location.path().split('/').pop();
        // Object to track the path values and their corresponding tabs
        var tabs = {
            'pta-and-pto-groups': 'first',
            'teachers-and-room-parents': 'second',
            'school-districts-and-administrators': 'third'
        };
        // Set the default selected tab based the the path value from the url, if a valid one is present, otherwise, pre-select the first tab.
        var tabSelected = tabs[urlTab] ? tabs[urlTab] : 'first';
        $scope.subgroup = tabSelected; // Can be 'first', 'second', or 'third'

        $scope.showsubgroup = function ( subgroup ) {
        $scope.subgroup = subgroup;
        };
    }]);
})();
